<template>
  <div class="communication-page" title="Communication">
    <div class="communication-page__header md-layout">
      <div class="md-layout-item">
        <div class="page-title">
          <span>{{ $t("communication.page_title") }}</span>
        </div>
      </div>
    </div>
    <div class="md-layout">
      <communication-tabs></communication-tabs>
    </div>
  </div>
</template>

<script>
import CommunicationTabs from "./Tabs";

export default {
  components: { CommunicationTabs }
};
</script>

<style lang="scss" scoped>
.communication-page {
  &__header {
    margin-bottom: 30px;

    .page-title {
      font-size: 1.5rem;
      color: #1b1f22;
      font-weight: 500;

      span {
        display: inline-block;
        margin-left: 15px;
      }
    }
  }
}
</style>
